export function getSubvencioInfoUrl(sourceUrl) {
    if (!sourceUrl) {
        return null;
    }

    try {
        const parsed = new URL(sourceUrl);

        if (parsed.hostname === 'tramits.gencat.cat') {
            const originalParams = new URLSearchParams(parsed.search);
            const infoParams = new URLSearchParams();

            infoParams.set('category', '');
            infoParams.set('moda', '1');
            originalParams.forEach((value, key) => {
                if (key !== 'category' && key !== 'moda') {
                    infoParams.append(key, value);
                }
            });

            parsed.search = infoParams.toString();
            return parsed.toString();
        }
    } catch {
        return sourceUrl;
    }

    return sourceUrl;
}

export function getSubvencioInfoHref(grant, applyHref = grant?.applyUrl || grant?.sourceUrl) {
    const infoUrl = getSubvencioInfoUrl(grant?.sourceUrl);
    return infoUrl && infoUrl !== applyHref ? infoUrl : null;
}
